// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1WeQo","productName":"Table_productName__3GTaN"};